import React from 'react';
import MainContent from './layout/MainContent';
import ParametersList from './parameters/ParametersList';
//Función princiapl
const Parameters = () => {
    //Nodos
    const nodes = [];
    //Acciones
    const actions = [];
    //Renderizo
    return (
        <MainContent 
            title='Parámetros' 
            subtitle='Listado' 
            nodes={nodes}
            actions={actions}
            component={ParametersList} />
    );
};

export default Parameters;